import React from 'react';
import { Label, TextField } from '@fluentui/react';

import styles from '../../styles/component.module.scss';

export interface ICustomTextField {
	label: string;
	description: string;
	required: boolean;
	error?: string;
	onChange: (value: string) => void;
}

export const CustomTextField = (props: ICustomTextField) => {
	const changeValue = (
		event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
		newValue?: string | undefined
	) => {
		props.onChange(newValue ? newValue : '');
	};

	return (
		<div>
			<Label required={props.required}>{props.label}</Label>
			<div>
				<TextField errorMessage={props.error} onChange={changeValue} />
				<p className={styles.descriptionText}>{props.description}</p>
			</div>
		</div>
	);
};
